import { render, staticRenderFns } from "./recharge-scheme.vue?vue&type=template&id=be4cf6ac&scoped=true&"
import script from "./recharge-scheme.vue?vue&type=script&lang=js&"
export * from "./recharge-scheme.vue?vue&type=script&lang=js&"
import style0 from "./recharge-scheme.vue?vue&type=style&index=0&id=be4cf6ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4cf6ac",
  null
  
)

export default component.exports